import { TestimonialCard } from "@/components/landing/testimonial-card";

const testimonials = [
  {
    author: {
      name: "Sarah Johnson",
      handle: "Job Seeker",
      avatar:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face",
    },
    text: "VacWork made my job search so much easier. Within two weeks, I found and secured a position that perfectly matches my skills and career goals.",
  },
  {
    author: {
      name: "Michael Chen",
      handle: "HR Manager",
      avatar:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    },
    text: "VacWork has transformed our recruitment process. We've reduced our time-to-hire by 40% and found exceptional candidates.",
  },
  {
    author: {
      name: "Emily Rodriguez",
      handle: "Recent Graduate",
      avatar:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
    },
    text: "VacWork connected me with entry-level opportunities that were perfect for my situation.",
  },
  {
    author: {
      name: "David Kim",
      handle: "Small Business Owner",
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
    text: "VacWork's platform made it simple to find qualified local talent without the usual hassle.",
  },
  {
    author: {
      name: "Lisa Patel",
      handle: "Career Changer",
      avatar:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    text: "VacWork helped me find opportunities that valued my transferable skills. I'm now thriving in my new industry!",
  },
  {
    author: {
      name: "James Wilson",
      handle: "Recruitment Director",
      avatar:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    },
    text: "VacWork has become our primary recruitment channel. The quality of candidates and the efficiency of the platform have exceeded our expectations.",
  },
];

export function TestimonialsSection() {
  return (
    <section
      className="border-border/50 border-t py-16 md:py-20 lg:py-24"
      id="testimonials"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 md:px-8">
        <div className="mb-12 flex flex-col items-center justify-center space-y-4 text-center md:mb-16 md:space-y-6 lg:mb-20">
          <h2 className="font-light text-2xl leading-tight tracking-tight sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
            What users say
          </h2>
          <p className="max-w-3xl text-left font-light text-base text-muted-foreground leading-relaxed sm:text-lg md:text-xl">
            See how VacWork has helped job seekers find their dream jobs and
            employers build amazing teams.
          </p>
        </div>

        <div
          className={
            "relative flex w-full flex-col items-center justify-center overflow-hidden"
          }
        >
          <div className="group flex flex-row gap-(--gap) overflow-hidden p-2 [--duration:40s] [--gap:2rem]">
            <div className="group-hover:paused flex shrink-0 animate-marquee flex-row justify-around gap-(--gap)">
              {[...new Array(4)].map((_, setIndex) =>
                testimonials.map((testimonial) => (
                  <TestimonialCard
                    {...testimonial}
                    key={`${setIndex}-${testimonial.author.name}`}
                  />
                ))
              )}
            </div>
          </div>

          <div className="pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-linear-to-r from-background to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-linear-to-l from-background to-transparent" />
        </div>
      </div>
    </section>
  );
}
